import React from "react";
import styles from "@fyendalscollection/marketing/lib/components/Button.module.scss";
import { useCallback } from "react";

export interface ButtonProps {
	children: React.ReactNode;
	style?: ButtonStyle;
	disabled?: boolean;
	isLoading?: boolean;
	onClick: () => void;
}

export enum ButtonStyle {
	Primary,
	Secondary
}

export const Button = (props: ButtonProps): JSX.Element => {
	const {
		children,
		style = ButtonStyle.Primary,
		disabled = false,
		isLoading: loading = false,
		onClick
	} = props;

	const onClickEnriched = useCallback(() => {
		if (disabled || loading) {
			return;
		}

		onClick();
	}, [onClick, disabled, loading]);

	const classNames = [ styles.button ];

	if (style === ButtonStyle.Primary) {
		classNames.push(styles.primary);
	}

	if (disabled) {
		classNames.push(styles.disabled);
	}

	if (loading) {
		classNames.push(styles.loading);
	}

	return (
		<div className={classNames.join(" ")} onClick={onClickEnriched}>
			<div></div>
			<div>{children}</div>
		</div>
	);
};
